<template>
  <v-chart :option="options" :init-options="{renderer: 'svg'}" style="height: 20px; width: 20px;"/>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import { graphic } from 'echarts/core'
import 'zrender/lib/svg/svg'

export default {
  computed: {
    options: function () {
      return {
        series: [{
          type: 'pie',
          selectedMode: 'single',
          silent: true,
          radius: ['0%', '100%'],
          label: {
            position: 'inner'
          },
          data: [
            {
              value: this.value,
              itemStyle: {
                color: new graphic.LinearGradient(0, 2, 0, 0, [
                  { offset: 0, color: 'white' },
                  { offset: 1, color: this.color }
                ])
              }
            },
            {
              value: 100 - this.value,
              itemStyle: {
                color: 'lightgray'
              }
            }
          ]
        }]
      }
    }
  },
  components: {
    'v-chart': ECharts
  },
  props: {
    color: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    }
  }
}
</script>
